/**
 * @generated SignedSource<<4237db293ded91536130395101ca4afc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_groupResults$data = {
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults" | "main_issueNavigator_IssueResults_groupResults">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_groupResults";
};
export type main_issueNavigator_IssueNavigatorUI_groupResults$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_groupResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_groupResults",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_groupResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults"
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "871331f4c58790bdf616c0f0f62fe7c4";

export default node;
